import {NgSpinKitModule} from 'ng-spin-kit';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
// import {DeleteModalModule} from './pages/delete-modal/delete-modal.module';
import {GlobalState} from './global.state';
import {AppTranslationModule} from './app.translation.module';
import {TranslateService} from '@ngx-translate/core';
// import {SessionService} from './session.service';
import {AppState} from './app.service';
import {NgModule} from '@angular/core';
import {HttpModule} from '@angular/http';
import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {CommonModule, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {ROUTES} from './app.routes';
import {AppComponent} from './app.component';
// App views
// import {DashboardsModule} from './views/dashboards/dashboards.module';
// import {AppviewsModule} from './views/appviews/appviews.module';
// App modules/components
import {LayoutsModule} from './components/common/layouts/layouts.module';
import {RestModule} from "app/services/rest.module";
import {AuthenticationGuard} from "./authentication.guard";
// import { ContainerComponent } from './pages/container/container.component';
import {BreadcrumbModule} from "./pages/breadcrumb/breadcrumb.module";
import {TableModule} from "./components/common/table/table.module";
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
// import {BsDropdownModule} from 'ngx-bootstrap';
// import {RollbackComponent} from './pages/rollback/rollback.component';
// import {GroupComponent} from './pages/group/group.component';
// import {RegistryListComponent} from './pages/registry-list/registry-list.component';
// import {NotifierService} from './pages/notifier/notifier.service';
import { ToastrModule } from 'ngx-toastr';
import {SharedModule} from "./services/shared/shared.module";

// Application wide providers
const APP_PROVIDERS = [
    AppState,
    GlobalState,
    AuthenticationGuard,
    // SessionService,
    // NotifierService
];

@NgModule({
    declarations: [
        AppComponent

        // ContainerComponent,
        // VmMigrationComponent,
        // RollbackComponent,
        // RegistryListComponent,
        // GroupComponent,

    ],
    imports: [
        RestModule,
        SharedModule,
        CommonModule,
        HttpModule,
        // DashboardsModule,
        LayoutsModule,
        HttpClientModule,
        // AppviewsModule,
        AppTranslationModule,
        // DeleteModalModule,
        RouterModule.forRoot(ROUTES),
        // BsDropdownModule.forRoot(),
        // ModalModule.forRoot(),
        // DeleteModalModule,
        BrowserAnimationsModule,
        NgSpinKitModule,
        BreadcrumbModule,
        TableModule,
        BsDatepickerModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        ToastrModule.forRoot()

    ],
    providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}, APP_PROVIDERS],
    bootstrap: [AppComponent]
})
export class AppModule {

    // constructor(public appState: AppState, private service: SessionService, public translate: TranslateService) {
    //   translate.setDefaultLang('pt');
    // }

    constructor(public appState: AppState, public translate: TranslateService) {
        translate.setDefaultLang('pt');
    }

}
